module.exports = __webpack_public_path__ + "img/43.0b3ec357.jpg";